import messages from './messages';
import { EMAIL_REGULAR_EXPRESSION } from '../../../utils/common/constants';

const usPhoneRegExp = /^\(\d{3}\) \d{3}-\d{4}$/;
const nameRegex = /^[a-z ,.'-]{2,30}$/i;

export default (values, { formatMessage, isShowingContactDetails }) => {
  const errors = {};

  if (!values.email) {
    errors.email = formatMessage(messages.requiredEmail);
  }

  if (values.email && !EMAIL_REGULAR_EXPRESSION.test(values.email)) {
    errors.email = formatMessage(messages.invalidEmail);
  }
  if (isShowingContactDetails && !values.email) {
    errors.email = formatMessage(messages.requiredEmail);
  }
  if (!values.firstName) {
    errors.firstName = formatMessage(messages.requiredFirstName);
  }
  if (values.firstName && !nameRegex.test(values.firstName)) {
    errors.firstName = formatMessage(messages.invalidFirstName);
  }
  if (!values.lastName) {
    errors.lastName = formatMessage(messages.requiredLastname);
  }

  if (values.lastName && !nameRegex.test(values.lastName)) {
    errors.lastName = formatMessage(messages.invalidLastName);
  }
  if (
    isShowingContactDetails &&
    values.phone &&
    !usPhoneRegExp.test(values.phone)
  ) {
    errors.phone = formatMessage(messages.invalidPhone);
  }
  if (isShowingContactDetails && !values.phone) {
    errors.phone = formatMessage(messages.invalidPhone);
  }
  if (!values.streetAddress) {
    errors.streetAddress = formatMessage(messages.requiredStreetName);
  }
  const isPOBox = values.streetAddress
    ?.replace(/[^a-zA-Z0-9]/g, '')
    .replace(' ', '')
    .toLowerCase()
    .includes('pobox');

  if (isPOBox) {
    errors.streetAddress = formatMessage(messages.notAcceptedPOBox);
  }

  if (!values.postalCode) {
    errors.postalCode = formatMessage(messages.requiredZipCode);
  }

  if (!values.city) {
    errors.city = formatMessage(messages.requiredCity);
  }
  if (!values.country) {
    errors.country = formatMessage(messages.required);
  }
  if (!values.state) {
    errors.state = formatMessage(messages.requiredState);
  }

  return errors;
};
